import { postAPI } from 'framework/api/http';
import { useMutation } from 'react-query';

interface SaveVideoInterface {
  title: string;
  coverImageUrl: string;
  videoUrl: string;
  category: string;
  lengthSeconds: number;
}

export const useSaveVideo = () => {
  const mutate = useMutation(
    ({ title, coverImageUrl, videoUrl, category, lengthSeconds }: SaveVideoInterface) => {
      return postAPI('/media-api/save_video_details', {
        title,
        cover_image_url: coverImageUrl,
        video_url: videoUrl,
        category,
        length_seconds: lengthSeconds,
      });
    },
  );

  return mutate;
};

export default useSaveVideo;
